import {ListItem} from '@github-ui/list-view/ListItem'
import {ListItemDescription} from '@github-ui/list-view/ListItemDescription'
import {ListItemMainContent} from '@github-ui/list-view/ListItemMainContent'
import {ListItemTitle} from '@github-ui/list-view/ListItemTitle'
import {Label, RelativeTime} from '@primer/react'
import {memo} from 'react'

import styles from './RepositoryProjects.module.css'
import type {Project} from './types'

interface ProjectRowProps {
  project: Project
}

function ProjectRowComponent({project}: ProjectRowProps) {
  const title = (
    <ListItemTitle value={project.title} href={project.url}>
      {!project.public && (
        <Label size="small" variant="secondary" className={styles.privateLabel}>
          Private
        </Label>
      )}
    </ListItemTitle>
  )

  return (
    <ListItem title={title} role="listitem" className={styles.projectRow}>
      <ListItemMainContent>
        <ListItemDescription className={styles.listItemContent}>
          {project.shortDescription && <p className={styles.projectDescription}>{project.shortDescription}</p>}
          <div className={styles.projectMeta}>
            <span>
              #{project.number}
              {project.updatedAt && (
                <>
                  {' '}
                  updated <RelativeTime date={new Date(project.updatedAt)} />
                </>
              )}
            </span>
          </div>
        </ListItemDescription>
      </ListItemMainContent>
    </ListItem>
  )
}

export const ProjectRow = memo(ProjectRowComponent)
